module.exports = __webpack_public_path__ + "static/media/ciancio-benjamin.879643d1.jpg";